<template>
  <section v-if="loading">
    <loading />
  </section>
  <section v-else>
    <h4 class="h4 color-blue font-weight-bold">
      Cancelamento do Clube de Vantagens
    </h4>
    <div v-if="retencao">
      <p>Você sabe o que está perdendo ao cancelar o seu clube?</p>
      <ul>
        <li>- Chance de captar novos clientes!</li>
        <li>- Anunciar sem cobrança de % sobre suas vendas!</li>
        <li>- Anúncios personalizados na sessão principal!</li>
        <li>- Anúncio veiculado no APP CDL Clube de Vantagens!</li>
        <li>
          - Anunciar com autonomia sobre a melhor forma de pagamento e entrega!
        </li>
        <li>
          - Chance de fidelizar seus clientes colocando ofertas exclusivas aqui!
        </li>
        <li>
          - Oportunidade de você, sua família e colaboradores usufruírem de mais
          de 30 mil ofertas mensais, Cashback, Cineclube com até 70% de desconto
          de segunda à segunda e Farmaclube, com descontos em todo o país que
          podem chegar a 90%.
        </li>
      </ul>
      <br />
      <p>
        Então, experimente utilizar todos estes benefícios ao seu favor, para
        isto temos uma proposta pra você, 50% de desconto no valor atual cobrado
        pelo seu Clube de Vantagens. Vamos aproveitar esta oportunidade de
        vender mais, fidelizar clientes e colaboradores e ainda economizar?
      </p>
    </div>
    <p v-else>
      Declaro estar ciente de que o cancelamento ocorrerá no primeiro dia do mês
      seguinte à esta solicitação. A CDL/BH não se responsabilizará por valores
      de cashback não resgatados e/ou acordos de compra e venda realizados pelo
      usuário e que ainda se encontrem pendentes na plataforma. Estou ciente e
      me responsabilizo total e integralmente por qualquer pendência e ônus que
      o cancelamento de cadastro venha gerar, de que os anúncios e usuários
      atrelados a este cadastro serão automaticamente suspensos conforme
      informado acima.
    </p>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          @click="$router.push({ name: 'clube-painel' })"
          nameClass="btn btn-outline-secondary btn-md btn-block"
          >VOLTAR</Botao
        >
      </div>
      <div class="col-md-4 col-lg-3 mt-3 mt-md-0" v-if="retencao">
        <Botao
          title="Voltar"
          :class="{ disabled: loading }"
          @click="!loading ? salvarRetencao() : ''"
          nameClass="btn btn-outline-success btn-md btn-block"
          ><span
            class="spinner-grow spinner-grow-sm pr-2"
            role="status"
            aria-hidden="true"
            v-show="loading"
          ></span>
          <span v-if="loading">SALVANDO...</span>
          <span v-else>ACEITAR DESCONTO</span></Botao
        >
      </div>
      <div class="col-md-4 col-lg-3">
        <Botao
          title="Enviar"
          :class="{ disabled: loading }"
          @click="!loading ? cancelar() : ''"
          nameClass="btn btn-outline-danger btn-md btn-block font-weight-bold"
        >
          <span
            class="spinner-grow spinner-grow-sm pr-2"
            role="status"
            aria-hidden="true"
            v-show="loading"
          ></span>
          <span v-if="loading">CANCELANDO...</span>
          <span v-else>EFETUAR CANCELAMENTO</span>
        </Botao>
      </div>
    </div>
    <div class="py-5"></div>
  </section>
</template>
<script>
import Botao from "@/components/botoes/Botao";
export default {
  name: "Cancelamento",
  components: { Botao },
  props: {
    cpfTitular: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      produto: {
        nome: "Clube de Vantagens",
        id: "Clube de Vantagens",
      },
      breadcrumb: [
        {
          nome: "Clube de Vantagens",
          id: "Clube de Vantagens",
          link: "/produto/clube-vantagens/painel",
        },
        {
          nome: "Cancelamento",
          id: "cancelamento",
          produto: "Clube de Vantagens",
        },
      ],
      voltar: true,
      loading: false,
      loadingSave: false,
      retencao: false,
    };
  },
  methods: {
    cancelar() {
      this.loading = true;
      const dados = this.gerarDados();
      this.$http
        .post("/api/Clube/CancelarClubeVantagens", dados)
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
              duration: 6000,
            });
            this.$router.push({ name: "clube-painel" });
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          console.error(error);
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "error",
          });
          this.loading = false;
        });
    },
    salvarRetencao() {
      this.loading = true;
      const dados = this.gerarDados();
      this.$http
        .post("/api/Clube/AceitarRetencaoClubeVantagens", dados)
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            this.$router.push({ name: "clube-painel" });
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "error",
          });
          this.loading = false;
        });
    },
    gerarDados() {
      if (!sessionStorage.ip) {
        fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      let d = new Date();
      let date = new Date(d.valueOf() - d.getTimezoneOffset() * 60000);

      const dadosTermo = {
        dtVersao: date,
        dtAceite: date,
        ipOrigem: sessionStorage.ip,
        browserData: navigator.appVersion,
      };

      return dadosTermo;
    },
  },
  async created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.loading = false;

    // Monta a rota para o botão voltar
    this.rotaVotar = "agenda";

    this.$http
      .get("/api/Clube/ConsultarRetencaoClubeVantagens")
      .then((response) => {
        if (response.data.ofertarRetencao) {
          this.retencao = true;
        } else {
          this.retencao = false;
        }
        this.loading = false;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
        this.loading = false;
      });
  },
};
</script>
